export const GIFT_SAME_DAY_DELIVERY = [
    { lng: -118.2202024, lat: 34.0183684 },
    { lng: -118.2202345, lat: 34.020547 },
    { lng: -118.2199234, lat: 34.0242374 },
    { lng: -118.2074459, lat: 34.0186265 },
    { lng: -118.1791642, lat: 34.0190179 },
    { lng: -118.1690796, lat: 34.0150694 },
    { lng: -118.1669047, lat: 34.0176287 },
    { lng: -118.1212291, lat: 34.0103638 },
    { lng: -118.0693873, lat: 33.9939724 },
    { lng: -118.0674407, lat: 34.001566 },
    { lng: -118.0568556, lat: 34.0096334 },
    { lng: -118.0529363, lat: 34.0187923 },
    { lng: -118.028446, lat: 34.0330669 },
    { lng: -118.02032, lat: 34.0396071 },
    { lng: -118.0107673, lat: 34.0434499 },
    { lng: -118.0002076, lat: 34.061425 },
    { lng: -117.9999706, lat: 34.0659192 },
    { lng: -117.9973071, lat: 34.0842938 },
    { lng: -117.9913794, lat: 34.0921067 },
    { lng: -117.9859613, lat: 34.095933 },
    { lng: -117.9775032, lat: 34.1154468 },
    { lng: -117.9629769, lat: 34.1274809 },
    { lng: -117.9570878, lat: 34.1343543 },
    { lng: -117.9562044, lat: 34.1360878 },
    { lng: -117.9485166, lat: 34.1364515 },
    { lng: -117.9399713, lat: 34.1402235 },
    { lng: -117.9286603, lat: 34.1527642 },
    { lng: -117.950483, lat: 34.1545035 },
    { lng: -117.9663883, lat: 34.1596298 },
    { lng: -117.9788617, lat: 34.1621985 },
    { lng: -117.9843819, lat: 34.1592953 },
    { lng: -118.0023352, lat: 34.1645907 },
    { lng: -118.0280109, lat: 34.1532626 },
    { lng: -118.024721, lat: 34.1662033 },
    { lng: -118.0241927, lat: 34.1714667 },
    { lng: -118.0555951, lat: 34.175308 },
    { lng: -118.0679827, lat: 34.1753533 },
    { lng: -118.0773106, lat: 34.1774395 },
    { lng: -118.0786244, lat: 34.1823252 },
    { lng: -118.0910431, lat: 34.1823059 },
    { lng: -118.0923726, lat: 34.1724643 },
    { lng: -118.0953744, lat: 34.1743703 },
    { lng: -118.0979456, lat: 34.1747754 },
    { lng: -118.0981088, lat: 34.1760125 },
    { lng: -118.1001493, lat: 34.180194 },
    { lng: -118.1001073, lat: 34.18373 },
    { lng: -118.1027895, lat: 34.1850379 },
    { lng: -118.1046134, lat: 34.1870558 },
    { lng: -118.1053431, lat: 34.1891035 },
    { lng: -118.1055124, lat: 34.1921842 },
    { lng: -118.1123764, lat: 34.1943748 },
    { lng: -118.1206153, lat: 34.195353 },
    { lng: -118.1226702, lat: 34.2012895 },
    { lng: -118.1305596, lat: 34.2043653 },
    { lng: -118.1597476, lat: 34.202009 },
    { lng: -118.1733079, lat: 34.207071 },
    { lng: -118.1757291, lat: 34.213006 },
    { lng: -118.1916108, lat: 34.2241428 },
    { lng: -118.2044985, lat: 34.2220018 },
    { lng: -118.2089902, lat: 34.2225463 },
    { lng: -118.2121384, lat: 34.2276122 },
    { lng: -118.2184383, lat: 34.2269566 },
    { lng: -118.2224574, lat: 34.2446732 },
    { lng: -118.2658873, lat: 34.2500182 },
    { lng: -118.2661554, lat: 34.2404023 },
    { lng: -118.276208, lat: 34.2463955 },
    { lng: -118.2764005, lat: 34.2451849 },
    { lng: -118.2740387, lat: 34.2430477 },
    { lng: -118.27292, lat: 34.2397665 },
    { lng: -118.2706804, lat: 34.234092 },
    { lng: -118.2892156, lat: 34.2359377 },
    { lng: -118.2926413, lat: 34.2336661 },
    { lng: -118.2988091, lat: 34.2325264 },
    { lng: -118.3035949, lat: 34.2336523 },
    { lng: -118.3097367, lat: 34.2333471 },
    { lng: -118.3130962, lat: 34.2338712 },
    { lng: -118.318103, lat: 34.2366219 },
    { lng: -118.3222834, lat: 34.237865 },
    { lng: -118.3272131, lat: 34.2363744 },
    { lng: -118.3336432, lat: 34.2367966 },
    { lng: -118.3449465, lat: 34.2348325 },
    { lng: -118.3560778, lat: 34.2341447 },
    { lng: -118.3577409, lat: 34.2339043 },
    { lng: -118.3672469, lat: 34.2342739 },
    { lng: -118.3656575, lat: 34.2242272 },
    { lng: -118.3659118, lat: 34.2225845 },
    { lng: -118.3700338, lat: 34.2179472 },
    { lng: -118.3702058, lat: 34.2155814 },
    { lng: -118.3708951, lat: 34.2007029 },
    { lng: -118.3825754, lat: 34.2011815 },
    { lng: -118.394615, lat: 34.2001379 },
    { lng: -118.4022436, lat: 34.2014073 },
    { lng: -118.4662445, lat: 34.20139 },
    { lng: -118.5360775, lat: 34.2012065 },
    { lng: -118.5359895, lat: 34.1688779 },
    { lng: -118.5357623, lat: 34.131142 },
    { lng: -118.5132538, lat: 34.1286117 },
    { lng: -118.5102391, lat: 34.1306124 },
    { lng: -118.5071006, lat: 34.1303336 },
    { lng: -118.5019861, lat: 34.1263576 },
    { lng: -118.5024423, lat: 34.1093557 },
    { lng: -118.5061076, lat: 34.1041213 },
    { lng: -118.5047663, lat: 34.0884969 },
    { lng: -118.5120815, lat: 34.0803257 },
    { lng: -118.5143692, lat: 34.0719738 },
    { lng: -118.512755, lat: 34.0699109 },
    { lng: -118.5061979, lat: 34.0657368 },
    { lng: -118.5093974, lat: 34.0591718 },
    { lng: -118.5215168, lat: 34.0571017 },
    { lng: -118.5259062, lat: 34.0551457 },
    { lng: -118.5296227, lat: 34.0501596 },
    { lng: -118.5299921, lat: 34.0471643 },
    { lng: -118.5355635, lat: 34.0358706 },
    { lng: -118.5247412, lat: 34.0321867 },
    { lng: -118.4971006, lat: 34.012994 },
    { lng: -118.4559944, lat: 33.9658049 },
    { lng: -118.4529652, lat: 33.968376 },
    { lng: -118.4586584, lat: 33.976637 },
    { lng: -118.4584131, lat: 33.9802016 },
    { lng: -118.4567438, lat: 33.9834081 },
    { lng: -118.4523025, lat: 33.9840152 },
    { lng: -118.446304, lat: 33.9831788 },
    { lng: -118.4443337, lat: 33.9809083 },
    { lng: -118.4381992, lat: 33.9769249 },
    { lng: -118.433072, lat: 33.9760694 },
    { lng: -118.4269026, lat: 33.9662442 },
    { lng: -118.426223, lat: 33.9638898 },
    { lng: -118.4324069, lat: 33.9651321 },
    { lng: -118.4478598, lat: 33.9602025 },
    { lng: -118.4509578, lat: 33.9634354 },
    { lng: -118.4535364, lat: 33.9623485 },
    { lng: -118.4349141, lat: 33.9304766 },
    { lng: -118.4271543, lat: 33.9166571 },
    { lng: -118.3618213, lat: 33.916862 },
    { lng: -118.362407, lat: 33.9650856 },
    { lng: -118.3526032, lat: 33.965197 },
    { lng: -118.3569702, lat: 33.9709458 },
    { lng: -118.3588094, lat: 33.9883403 },
    { lng: -118.2775559, lat: 33.9892106 },
    { lng: -118.2430198, lat: 33.9896012 },
    { lng: -118.2429106, lat: 34.0040318 },
    { lng: -118.2301558, lat: 34.0038494 },
    { lng: -118.2299561, lat: 34.0088829 },
    { lng: -118.2308087, lat: 34.0184635 },
    { lng: -118.2202024, lat: 34.0183684 }
];

export const GIFT_DAYS_NOTICE_DELIVERY_1 = [
    { lng: -118.637495, lat: 34.2651615 },
    { lng: -118.6453497, lat: 34.2632457 },
    { lng: -118.6450707, lat: 34.262004 },
    { lng: -118.6484503, lat: 34.2590423 },
    { lng: -118.6513138, lat: 34.2427433 },
    { lng: -118.6499403, lat: 34.2401179 },
    { lng: -118.6487386, lat: 34.2393728 },
    { lng: -118.6462495, lat: 34.2384326 },
    { lng: -118.6452626, lat: 34.2368272 },
    { lng: -118.6434816, lat: 34.2367341 },
    { lng: -118.6427629, lat: 34.2351975 },
    { lng: -118.6445331, lat: 34.2320997 },
    { lng: -118.6470223, lat: 34.2279833 },
    { lng: -118.6471082, lat: 34.223583 },
    { lng: -118.6470652, lat: 34.2187569 },
    { lng: -118.6453058, lat: 34.2154922 },
    { lng: -118.6475372, lat: 34.2100986 },
    { lng: -118.6484817, lat: 34.2083951 },
    { lng: -118.6523012, lat: 34.2076143 },
    { lng: -118.6554336, lat: 34.2037812 },
    { lng: -118.6563398, lat: 34.1980037 },
    { lng: -118.6570505, lat: 34.1917426 },
    { lng: -118.6553579, lat: 34.1887474 },
    { lng: -118.6563126, lat: 34.1804578 },
    { lng: -118.6547888, lat: 34.1780791 },
    { lng: -118.6513984, lat: 34.1767302 },
    { lng: -118.6453057, lat: 34.1711924 },
    { lng: -118.6402841, lat: 34.1657597 },
    { lng: -118.6382884, lat: 34.1633983 },
    { lng: -118.6380954, lat: 34.1608239 },
    { lng: -118.632602, lat: 34.1537923 },
    { lng: -118.6305422, lat: 34.1523007 },
    { lng: -118.6295983, lat: 34.1472574 },
    { lng: -118.630371, lat: 34.1429955 },
    { lng: -118.6313152, lat: 34.1410596 },
    { lng: -118.6305428, lat: 34.1368504 },
    { lng: -118.6319161, lat: 34.1347725 },
    { lng: -118.6338043, lat: 34.1339733 },
    { lng: -118.6358644, lat: 34.1292131 },
    { lng: -118.6418724, lat: 34.126016 },
    { lng: -118.63758, lat: 34.1235285 },
    { lng: -118.6342325, lat: 34.1244164 },
    { lng: -118.6322157, lat: 34.1225866 },
    { lng: -118.6330956, lat: 34.1203927 },
    { lng: -118.6351664, lat: 34.1191538 },
    { lng: -118.6339701, lat: 34.1171133 },
    { lng: -118.634402, lat: 34.1136059 },
    { lng: -118.6340171, lat: 34.1117102 },
    { lng: -118.6302199, lat: 34.1094122 },
    { lng: -118.6289119, lat: 34.1044137 },
    { lng: -118.6270653, lat: 34.1038453 },
    { lng: -118.6239105, lat: 34.1042718 },
    { lng: -118.6218183, lat: 34.1030635 },
    { lng: -118.6210298, lat: 34.1011089 },
    { lng: -118.6186616, lat: 34.1001317 },
    { lng: -118.616791, lat: 34.0976529 },
    { lng: -118.6131951, lat: 34.0955606 },
    { lng: -118.604536, lat: 34.0901986 },
    { lng: -118.6038926, lat: 34.0893452 },
    { lng: -118.6058235, lat: 34.0841565 },
    { lng: -118.6073692, lat: 34.0777226 },
    { lng: -118.6171531, lat: 34.0674495 },
    { lng: -118.6180973, lat: 34.0624722 },
    { lng: -118.6169815, lat: 34.0592015 },
    { lng: -118.6136329, lat: 34.0591308 },
    { lng: -118.6104138, lat: 34.0598775 },
    { lng: -118.6062294, lat: 34.0593973 },
    { lng: -118.589859, lat: 34.0435565 },
    { lng: -118.5894513, lat: 34.0389336 },
    { lng: -118.5844194, lat: 34.0377156 },
    { lng: -118.581276, lat: 34.0388002 },
    { lng: -118.578701, lat: 34.0400004 },
    { lng: -118.5759544, lat: 34.0400004 },
    { lng: -118.5726071, lat: 34.0416363 },
    { lng: -118.5687447, lat: 34.0419918 },
    { lng: -118.5637664, lat: 34.0412096 },
    { lng: -118.5591316, lat: 34.0394314 },
    { lng: -118.5556984, lat: 34.0382934 },
    { lng: -118.550377, lat: 34.0395026 },
    { lng: -118.5460854, lat: 34.0397159 },
    { lng: -118.5405668, lat: 34.0383624 },
    { lng: -118.5355635, lat: 34.0358706 },
    { lng: -118.5299326, lat: 34.047389 },
    { lng: -118.5296227, lat: 34.0501596 },
    { lng: -118.5259062, lat: 34.0551457 },
    { lng: -118.5215168, lat: 34.0571017 },
    { lng: -118.5093974, lat: 34.0591718 },
    { lng: -118.5061979, lat: 34.0657368 },
    { lng: -118.512755, lat: 34.0699109 },
    { lng: -118.5143692, lat: 34.0719738 },
    { lng: -118.5120815, lat: 34.0803257 },
    { lng: -118.5047663, lat: 34.0884969 },
    { lng: -118.5061076, lat: 34.1041213 },
    { lng: -118.5024423, lat: 34.1093557 },
    { lng: -118.5019861, lat: 34.1263576 },
    { lng: -118.5071006, lat: 34.1303336 },
    { lng: -118.5102391, lat: 34.1306124 },
    { lng: -118.5132538, lat: 34.1286117 },
    { lng: -118.5357623, lat: 34.131142 },
    { lng: -118.5360775, lat: 34.2012065 },
    { lng: -118.4022436, lat: 34.2014073 },
    { lng: -118.394615, lat: 34.2001379 },
    { lng: -118.3825754, lat: 34.2011815 },
    { lng: -118.3708951, lat: 34.2007029 },
    { lng: -118.3700338, lat: 34.2179472 },
    { lng: -118.3656575, lat: 34.2242272 },
    { lng: -118.3672469, lat: 34.2342739 },
    { lng: -118.3560778, lat: 34.2341447 },
    { lng: -118.3361395, lat: 34.2363744 },
    { lng: -118.3272131, lat: 34.2363744 },
    { lng: -118.3222834, lat: 34.237865 },
    { lng: -118.318103, lat: 34.2366219 },
    { lng: -118.3130962, lat: 34.2338712 },
    { lng: -118.3097367, lat: 34.2333471 },
    { lng: -118.3035949, lat: 34.2336523 },
    { lng: -118.2988091, lat: 34.2325264 },
    { lng: -118.2926413, lat: 34.2336661 },
    { lng: -118.2892156, lat: 34.2359377 },
    { lng: -118.2706804, lat: 34.234092 },
    { lng: -118.2740387, lat: 34.2430477 },
    { lng: -118.276208, lat: 34.2463955 },
    { lng: -118.2661554, lat: 34.2404023 },
    { lng: -118.2658873, lat: 34.2500182 },
    { lng: -118.2680866, lat: 34.2507256 },
    { lng: -118.2703715, lat: 34.2523196 },
    { lng: -118.2720646, lat: 34.2538673 },
    { lng: -118.2748003, lat: 34.2545261 },
    { lng: -118.2780576, lat: 34.2622415 },
    { lng: -118.2869525, lat: 34.271061 },
    { lng: -118.2910415, lat: 34.2731952 },
    { lng: -118.2955888, lat: 34.272609 },
    { lng: -118.3019394, lat: 34.2746651 },
    { lng: -118.3065301, lat: 34.2767559 },
    { lng: -118.3152453, lat: 34.2746836 },
    { lng: -118.3384507, lat: 34.2771229 },
    { lng: -118.3546148, lat: 34.2789876 },
    { lng: -118.3671845, lat: 34.283291 },
    { lng: -118.3826309, lat: 34.2855016 },
    { lng: -118.3968949, lat: 34.2879736 },
    { lng: -118.4053659, lat: 34.2882827 },
    { lng: -118.4161377, lat: 34.2976783 },
    { lng: -118.4111171, lat: 34.3013564 },
    { lng: -118.4126195, lat: 34.3025529 },
    { lng: -118.3993149, lat: 34.3150841 },
    { lng: -118.3989502, lat: 34.31675 },
    { lng: -118.3971263, lat: 34.3168918 },
    { lng: -118.3980275, lat: 34.3194083 },
    { lng: -118.3975983, lat: 34.3224565 },
    { lng: -118.4046364, lat: 34.3236616 },
    { lng: -118.4058643, lat: 34.3289432 },
    { lng: -118.4255464, lat: 34.330255 },
    { lng: -118.44105, lat: 34.3291914 },
    { lng: -118.4410715, lat: 34.3247249 },
    { lng: -118.4468651, lat: 34.3244059 },
    { lng: -118.4514999, lat: 34.3238742 },
    { lng: -118.4827423, lat: 34.3227401 },
    { lng: -118.4975052, lat: 34.3207553 },
    { lng: -118.5108948, lat: 34.2994865 },
    { lng: -118.5380173, lat: 34.2923957 },
    { lng: -118.5517502, lat: 34.3000537 },
    { lng: -118.5726929, lat: 34.2992028 },
    { lng: -118.5884857, lat: 34.2940975 },
    { lng: -118.5922623, lat: 34.2736731 },
    { lng: -118.6063385, lat: 34.2782123 },
    { lng: -118.6283112, lat: 34.2742405 },
    { lng: -118.6368942, lat: 34.2668638 },
    { lng: -118.637495, lat: 34.2651615 }
];

export const GIFT_DAYS_NOTICE_DELIVERY_2 = [
    { lng: -118.0693873, lat: 33.9939724 },
    { lng: -118.1212291, lat: 34.0103638 },
    { lng: -118.1669047, lat: 34.0176287 },
    { lng: -118.1690796, lat: 34.0150694 },
    { lng: -118.1791642, lat: 34.0190179 },
    { lng: -118.2074459, lat: 34.0186265 },
    { lng: -118.2199234, lat: 34.0242374 },
    { lng: -118.2202024, lat: 34.0183684 },
    { lng: -118.2308087, lat: 34.0184635 },
    { lng: -118.2301558, lat: 34.0038494 },
    { lng: -118.2429106, lat: 34.0040318 },
    { lng: -118.2430198, lat: 33.9896012 },
    { lng: -118.3588094, lat: 33.9883403 },
    { lng: -118.3569702, lat: 33.9709458 },
    { lng: -118.3526032, lat: 33.965197 },
    { lng: -118.362407, lat: 33.9650856 },
    { lng: -118.3618213, lat: 33.916862 },
    { lng: -118.3787155, lat: 33.9170103 },
    { lng: -118.4271543, lat: 33.9166571 },
    { lng: -118.4218025, lat: 33.9054708 },
    { lng: -118.4060097, lat: 33.872411 },
    { lng: -118.3981133, lat: 33.8533102 },
    { lng: -118.3936501, lat: 33.8464671 },
    { lng: -118.3917618, lat: 33.8463245 },
    { lng: -118.3879852, lat: 33.8386253 },
    { lng: -118.3898735, lat: 33.8359162 },
    { lng: -118.3900452, lat: 33.8199449 },
    { lng: -118.3854103, lat: 33.8193744 },
    { lng: -118.3806038, lat: 33.816522 },
    { lng: -118.3763123, lat: 33.8160942 },
    { lng: -118.3711624, lat: 33.8143827 },
    { lng: -118.3656693, lat: 33.8105318 },
    { lng: -118.3481598, lat: 33.8039705 },
    { lng: -118.3287621, lat: 33.7897052 },
    { lng: -118.3076477, lat: 33.7897052 },
    { lng: -118.307476, lat: 33.7875652 },
    { lng: -118.3097076, lat: 33.783285 },
    { lng: -118.3086777, lat: 33.7734398 },
    { lng: -118.3127975, lat: 33.7597403 },
    { lng: -118.3107376, lat: 33.7570287 },
    { lng: -118.309021, lat: 33.7533179 },
    { lng: -118.309536, lat: 33.7437547 },
    { lng: -118.3114243, lat: 33.7394724 },
    { lng: -118.3158875, lat: 33.7380449 },
    { lng: -118.3167458, lat: 33.7336195 },
    { lng: -118.3143425, lat: 33.730907 },
    { lng: -118.3114243, lat: 33.7263385 },
    { lng: -118.3127975, lat: 33.7230547 },
    { lng: -118.3122826, lat: 33.7143449 },
    { lng: -118.3006096, lat: 33.7110607 },
    { lng: -118.2937431, lat: 33.7069195 },
    { lng: -118.291018, lat: 33.705795 },
    { lng: -118.2879066, lat: 33.7070623 },
    { lng: -118.2865548, lat: 33.7073118 },
    { lng: -118.2853209, lat: 33.7092751 },
    { lng: -118.2853477, lat: 33.7163612 },
    { lng: -118.2828292, lat: 33.7196633 },
    { lng: -118.2844305, lat: 33.7244646 },
    { lng: -118.2774353, lat: 33.7261957 },
    { lng: -118.2798386, lat: 33.7294794 },
    { lng: -118.2794952, lat: 33.7411853 },
    { lng: -118.2805252, lat: 33.7497497 },
    { lng: -118.2832718, lat: 33.7524615 },
    { lng: -118.286705, lat: 33.7514624 },
    { lng: -118.2911682, lat: 33.7518906 },
    { lng: -118.2894516, lat: 33.7587413 },
    { lng: -118.2846451, lat: 33.7627373 },
    { lng: -118.2805252, lat: 33.7715848 },
    { lng: -118.2772636, lat: 33.7705859 },
    { lng: -118.2554626, lat: 33.7714421 },
    { lng: -118.2444763, lat: 33.7810022 },
    { lng: -118.2209587, lat: 33.7822863 },
    { lng: -118.2039642, lat: 33.7760083 },
    { lng: -118.2043076, lat: 33.7660195 },
    { lng: -118.1892014, lat: 33.7613101 },
    { lng: -118.1821632, lat: 33.7650206 },
    { lng: -118.1469727, lat: 33.7601684 },
    { lng: -118.1349564, lat: 33.7544597 },
    { lng: -118.1303215, lat: 33.7524615 },
    { lng: -118.1316948, lat: 33.7561723 },
    { lng: -118.1272316, lat: 33.7543169 },
    { lng: -118.1205368, lat: 33.751177 },
    { lng: -118.1183052, lat: 33.752747 },
    { lng: -118.1145287, lat: 33.7523188 },
    { lng: -118.1176186, lat: 33.7564578 },
    { lng: -118.1044006, lat: 33.7590267 },
    { lng: -118.1035423, lat: 33.7744387 },
    { lng: -118.0918694, lat: 33.774296 },
    { lng: -118.0918694, lat: 33.7837131 },
    { lng: -118.0862045, lat: 33.7974088 },
    { lng: -118.0832863, lat: 33.8002618 },
    { lng: -118.081398, lat: 33.8039705 },
    { lng: -118.081398, lat: 33.8219414 },
    { lng: -118.0820847, lat: 33.8270753 },
    { lng: -118.0934143, lat: 33.8481779 },
    { lng: -118.0956459, lat: 33.8571592 },
    { lng: -118.1040573, lat: 33.8812472 },
    { lng: -118.1052589, lat: 33.9021939 },
    { lng: -118.1045723, lat: 33.9221384 },
    { lng: -118.1030273, lat: 33.9285482 },
    { lng: -118.0970192, lat: 33.9403693 },
    { lng: -118.0872345, lat: 33.9574572 },
    { lng: -118.0834579, lat: 33.9665694 },
    { lng: -118.0776215, lat: 33.9788123 },
    { lng: -118.0709267, lat: 33.9872105 },
    { lng: -118.0693873, lat: 33.9939724 }
]


// WEBPACK FOOTER //
// ./src/utils/giftDeliveryRegions.js